import React from "react";
import { Link, useLocation } from "react-router-dom";
import format from "date-fns/format";
import PortalKycHeatIndicator from "./PortalKycHeatIndicator";
import { formatDateAsDaysAgo } from "../../utilities/daysFromDate";
import { formatLegDepTimeDisplay } from "../../utilities/formatLegDepTimeDisplay";
import onewayPortal from "../../assets/icons/oneway-portal.png";
import multilegPortal from "../../assets/icons/multileg-portal.png";
import refreshCw from "../../assets/icons/refresh-cw.svg";
import tickIconGreen from "../../assets/icons/tick-icon-green.svg";
import crossIconRed from "../../assets/icons/cross-icon-red.svg";
import questionIcon from "../../assets/icons/question-icon.svg";

const PortalDealCard = ({ deal }) => {
    const location = useLocation();
    const returnTo = `${location.pathname}${location.search}`;
    // useEffect(() => {
    //     console.log(deal.legs.sort((a, b) => {return a.legNumber < b.legNumber ? -1 : 1}))
    // })

    const updatedDate = new Date(deal.modified_Time);
    const legsCount = deal.legs ? deal.legs.length : 0;
    const isOneWay = legsCount === 1;
    const isReturn = legsCount === 2;
    const isMultiLeg = legsCount > 2;
    // TODO: refine multi-leg detection — some 2-leg trips are multi-leg

    const formatLegDate = (d) => {
        if (!d) return "-";
        if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d.trim())) {
            const [y, m, day] = d.trim().split("-");
            return `${day}/${m}/${y.slice(2)}`;
        }
        const dt = new Date(d);
        if (Number.isNaN(dt.getTime())) return "-";
        return format(dt, "dd/MM/yy", { awareOfUnicodeTokens: true });
    };

    return (
        <div className={"portal__deal_card"}>
            <div className={"deal_card_header"}>
                <Link
                    to={`/portal/deal-details/sales/${deal.id}`}
                    state={{ deal, returnTo }}
                    className={"deal_card_tripName"}
                >
                    <h2>
                        {isOneWay && <img src={onewayPortal} alt="" className={"deal_card_title_arrow"} />}
                        {isReturn && <img src={refreshCw} alt="" className={"deal_card_title_arrow"} />}
                        {isMultiLeg && <img src={multilegPortal} alt="" className={"deal_card_title_arrow"} />}
                        {isMultiLeg
                            ? `MULTI-LEG (${legsCount}) for ${
                                  deal.leadFullName.trim().length ? deal.leadFullName : deal.contactFullName
                              }`
                            : deal.deal_Name}
                    </h2>
                </Link>
                <div className={"deal_card_header_meta"}>
                    <div className={"deal_card_timestamp"}>
                        UPDATED: {formatDateAsDaysAgo(updatedDate).toUpperCase()}
                    </div>
                    <div className={"deal_card_kyc"}>
                        {deal.kyC_Heat && <PortalKycHeatIndicator kycHeat={deal.kyC_Heat} />}
                    </div>
                </div>
            </div>
            <div className={"gold_divider"}></div>

            <div className={"deal_card_info_row"}>
                <div className={"deal_card_info_column"}>
                    <p className={"deal_card_info_item"}>
                        <span className={"deal_card_info_label"}>
                            {deal.leadFullName.trim().length ? "Lead" : "Client"} Name:
                        </span>
                        <span className={"deal_card_info_value"}>
                            {deal.leadFullName.trim().length ? deal.leadFullName : deal.contactFullName}
                        </span>
                    </p>
                    {deal.tenantID && (
                        <p className={"deal_card_info_item"}>
                            <span className={"deal_card_info_label"}>Tenant ID:</span>
                            <span className={"deal_card_info_value"}>{deal.tenantID}</span>
                        </p>
                    )}
                    {deal.ownerFullName && (
                        <p className={"deal_card_info_item"}>
                            <span className={"deal_card_info_label"}>Deal Owner:</span>
                            <span className={"deal_card_info_value"}>{deal.ownerFullName}</span>
                        </p>
                    )}
                    <p className={"deal_card_info_item"}>
                        <span className={"deal_card_info_label"}>Deal Stage:</span>
                        <span className={"deal_card_info_value"}>{deal.stage}</span>
                    </p>
                </div>

                {deal.legs && (
                    <div className={"deal_card_info_column deal_card_info_column--route"}>
                        {deal.legs
                            .sort((a, b) => {
                                return a.legNumber < b.legNumber ? -1 : 1;
                            })
                            .map((leg, index) => (
                                <p key={`${deal.id}-${index}`} className={"deal_card_info_item deal_card_leg-row"}>
                                    <span className={"deal_card_leg-route"}>
                                        <strong>Leg {index + 1}:</strong> {leg.legFrom} - {leg.legTo}
                                    </span>
                                    <span className={"deal_card_leg-date"}>
                                        <strong>Dep Date:</strong> {formatLegDate(leg.legDate)}
                                    </span>
                                    <span className={"deal_card_leg-time"}>
                                        <strong>Dep Time:</strong> {formatLegDepTimeDisplay(leg.legTime)}
                                    </span>
                                </p>
                            ))}
                    </div>
                )}
            </div>

            <div className={"deal_card_divider"}></div>

            <div className={"deal_card_status_row"}>
                {deal.avinodeTripId && <span className={"deal_card_trip_id"}>TRIP ID: {deal.avinodeTripId}</span>}

                {deal.quoteStats && (
                    <div className={"deal_card_status_icons"}>
                        <div className={"deal_card_status_item"}>
                            {deal.quoteStats.accepted}
                            <img src={tickIconGreen} alt="" />
                        </div>
                        <div className={"deal_card_status_item"}>
                            {deal.quoteStats.declined}
                            <img src={crossIconRed} alt="" />
                        </div>
                        <div className={"deal_card_status_item"}>
                            {deal.quoteStats.unanswered}
                            <img src={questionIcon} alt="" />
                        </div>
                    </div>
                )}

                {deal.ownerFullName && (
                    <span className={"deal_card_avinode_user"}>AVINODE USER: {deal.ownerFullName.toUpperCase()}</span>
                )}
            </div>
        </div>
    );
};

export default PortalDealCard;
